var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDelivery = function SvgDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 88 88"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF5C32",
    strokeWidth: 4,
    d: "M74.215 65.16c-3.774 6.397-11.31 8.523-16.697 5.323-5.388-3.2-7.156-10.85-3.383-17.247 3.775-6.397 11.31-8.523 16.697-5.324 5.389 3.2 7.157 10.85 3.383 17.247ZM29.472 65.16c-3.774 6.397-11.308 8.523-16.697 5.323-5.388-3.2-7.156-10.85-3.382-17.247 3.774-6.397 11.31-8.523 16.697-5.324 5.388 3.2 7.156 10.85 3.382 17.247ZM31.181 53.803h22.173"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF5C32",
    strokeWidth: 4,
    d: "M8.002 53.803c-3.047 0-5.316-2.811-4.672-5.789L7.03 30.888a5.694 5.694 0 0 1 5.566-4.491 5.694 5.694 0 0 0 5.163-3.293l3.227-6.94a8 8 0 0 1 7.254-4.627h30.925a8 8 0 0 1 7.811 6.27l.514 2.32a8 8 0 0 0 7.81 6.27h2.323c5.023 0 8.804 4.576 7.856 9.51l-2.21 11.499a7.885 7.885 0 0 1-7.743 6.398"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5C32",
    d: "M46.64 70.4h16.72v3.52H46.64zM1.76 70.4h16.72v3.52H1.76z"
  })));
};
export default SvgDelivery;